export default __webpack_public_path__ + "static/media/3.4e3750a6.png";